export const lang = {
  account: 'Account',
  password: 'Password',
  nickname: 'Nickname',
  accountInfo: 'Enter account number/email',
  passwordInfo: 'Please enter password',

  passwordInfo1: 'Please enter the password again',

  passwordInfo2: 'The two input passwords are inconsistent',
  nicknameInfo: 'Please enter your nickname',
  login: 'Login',
  register: 'Register',
  language: 'Language',
  zh: 'Chinese',
  en: 'English',
  loginError1: 'Account password cannot be empty',
  loginError2: 'Password error',
  loginError3: 'Account does not exist',

  loginError4: 'Do not login repeatedly',
  loginError5: 'Account is not a mobile phone number',
  loginError6: 'The mobile phone number or email address format is incorrect',

  loginSuccess: 'Login success',
  // function1: "location roaming",
  // function2: "custom skin",
  // function3: "interactive action",
  // function4: 'user manage',
  // logOut: 'log out',
  // logOutInfo: 'exit login?',
  // close: 'close',
  // online: 'online',
  // AccName: [
  //     "Sex",
  //     "Accessory",
  //     "Hair",
  //     "Hat",
  //     "Suit",
  //     "Hair color",
  //     "Skin color"
  // ],
  // sendError: 'The content you sent cannot be empty',
  // sendInfo: 'please enter content',
  // send: 'send',
  // peopleOnline: 'people online',
  // world: 'world',
  // clientError: "You haven't entered the conference room yet, so you don't have permission",
  // videoError: "you don't have a camera",
  // micError: `you don't have a microphone, failed to enter the room`,
  // saveInfo: 'Saved successfully',
  // shareError: 'someone has shared the screen at present',

  // online: '在线人数',
  logOutInfo: 'Log out?',

  AccName: ['性别', '配饰', '头发', '帽子', '套装', '发色', '肤色'],
  sendError: '您发送的内容不能为空',
  sendInfo: '请输入内容',
  send: '发送',
  peopleOnline: '人在线',
  world: '世界',
  clientError: '您还未进入会议室，暂无权限',
  videoError: '您没有摄像头',
  micError: '您没有麦克风,进入房间失败',
  shareError: `当前已有人分享屏幕`,
  saveInfo: '保存成功',

  before1: 'Please select exhibition hall',
  before2: 'The exhibition hall is closed',
  before3: 'Exhibition hall expired',
  before4: 'The exhibition hall is not open yet',
  before5: 'Enter the hall',
  before6: 'Opening hours',
  before7: 'to',

  login1: 'Slide to the right',
  login2: 'Verification failed',
  login3: 'Registered successfully',

  validate1: 'Verification code cannot be empty',
  validate2: 'Incorrect verification code, please re-enter',
  validate3: 'OK'
}
